export interface HighlightRange {
  text: string;
  highlighted: boolean;
}

export function getHighlightRanges(text: string, term: string): HighlightRange[] {
  if (!term) return [{ text, highlighted: false }];

  const lowerText = text.toLowerCase();
  const lowerTerm = term.toLowerCase();
  const ranges: HighlightRange[] = [];
  let cursor = 0;

  // Slice with `lowerTerm.length`, not `term.length` — they differ when `toLowerCase()`
  // changes length (e.g. German ß), and indices are in `lowerText`'s space.
  while (cursor < text.length) {
    const matchIndex = lowerText.indexOf(lowerTerm, cursor);

    if (matchIndex === -1) {
      ranges.push({ text: text.slice(cursor), highlighted: false });
      break;
    }

    if (matchIndex > cursor) {
      ranges.push({ text: text.slice(cursor, matchIndex), highlighted: false });
    }

    ranges.push({ text: text.slice(matchIndex, matchIndex + lowerTerm.length), highlighted: true });
    cursor = matchIndex + lowerTerm.length;
  }

  return ranges;
}
